<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Klasifikatorius</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <el-overlay-loading :loading="modalloading" />
            <v-row>
              <v-col cols="12">
                <el-text-field
                  :readonly="!isNaujas || readonly"
                  label="Kodas"
                  tooltip="Administravimas. Klasifikatoriai. Modal. Kodas"
                  v-model="item.kla_kodas"
                />
              </v-col>
              <v-col cols="12">
                <el-text-field
                  :readonly="!isNaujas || readonly"
                  :required="isNaujas"
                  label="Reikšmė"
                  tooltip="Administravimas. Klasifikatoriai. Modal. Reikšmė"
                  v-model="item.kla_reiksme"
                />
              </v-col>
              <v-col cols="6">
                <el-date-picker
                  :readonly="item.yraGaliojaNuo || readonly"
                  :required="!item.yraGaliojaNuo"
                  label="Galioja nuo"
                  tooltip="Administravimas. Klasifikatoriai. Modal. Galioja nuo"
                  future-dates
                  v-model="item.kla_galioja_nuo"
                />
              </v-col>
              <v-col cols="6">
                <el-date-picker
                  :readonly="readonly || !item.redaguojama_data"
                  label="Galioja iki"
                  tooltip="Administravimas. Klasifikatoriai. Modal. Galioja iki"
                  future-dates
                  v-model="item.kla_galioja_iki"
                />
              </v-col>
              <v-col cols="12" md="12">
                <template v-for="rodytiItem in rodytiList">
                  <el-checkbox
                    :key="rodytiItem.value"
                    :check-value="rodytiItem.value"
                    :required="true"
                    :readonly="readonly"
                    class="mr-5 mb-5"
                    :label="rodytiItem.text"
                    silent
                    inline
                    v-model="selectedRodyti"
                  />
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()" :loading="modalloading">
          Atšaukti
        </el-button>
        <el-button
          v-if="!readonly"
          primary
          @click.native="saveData()"
          :loading="modalloading"
        >
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalKlasifikatorius',
  props: {
    value: Boolean,
    readonly: Boolean,
    item: Object,
  },
  data() {
    return {
      loading: true,
      loadingRegistras: false,
      modalDaiktas: {},
      modalloading: true,
      selectedRodyti: [],
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isNaujas() {
      return !(this.item.kla_id > 0)
    },
    rodytiList() {
      return [
        {
          text: 'Rodoma darbo vietoje',
          value: 'darbo_vieta',
        },
        {
          text: 'Rodoma el. paslaugose',
          value: 'savitarna',
        },
      ]
    },
  },
  watch: {
    selectedRodyti() {
      this.item.kla_darbo_vieta = this.selectedRodyti.includes('darbo_vieta')
      this.item.kla_savitarna = this.selectedRodyti.includes('savitarna')
    },
  },
  created() {
    this.modalloading = false
    this.item.kla_darbo_vieta && this.selectedRodyti.push('darbo_vieta')
    this.item.kla_savitarna && this.selectedRodyti.push('savitarna')
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.modalloading = true

          const data = {
            kla_id: this.item.kla_id,
            kla_kodas: this.item.kla_kodas,
            kla_reiksme: this.item.kla_reiksme,
            kla_galioja_nuo: this.item.kla_galioja_nuo,
            kla_galioja_iki: this.item.kla_galioja_iki,
            kla_darbo_vieta: this.item.kla_darbo_vieta,
            kla_savitarna: this.item.kla_savitarna,
          }

          this.$axios
            .post(`admin/klasifikatorius/${this.item.klg_id}`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.closeModal()
              this.$emit('savedData', this.item)
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.modalloading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      if (!this.readonly) {
        this.saveData()
      }
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
